import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { List } from 'immutable';
import { IOverviewMetric } from '../overview-metric/overview-metric.interface';
import { ITrackingObject } from 'i2g-ng-tracking';
import { TrackingScreenNamesEnum } from '../../../tracking/tracking.data';

@Component({
  selector: 'app-overview-metric-list',
  templateUrl: './overview-metric-list.component.html',
  styleUrls: ['./overview-metric-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverviewMetricListComponent implements OnInit {
  @Input() numberOfPlaceholderMetrics: number;
  @Input() miniSize?: boolean;
  @Input() metrics: List<IOverviewMetric>;
  @Input() evenlySpaceMetrics: boolean;

  @Input() trackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @HostBinding('class.evenly-spaced')
  get evenlySpacedComponentCSSClass(): boolean {
    return this.evenlySpaceMetrics;
  }

  @HostBinding('class.mini-metric')
  get miniMetricComponentCSSClass(): boolean {
    return this.miniSize;
  }

  constructor() {}

  ngOnInit() {}
}
